/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { ACTION_TYPES, getPriceStr, toTitleCase, buildingTypes } from "./utils"
import { useLocation } from "@reach/router"
import { defaultArea } from "@constants";

import _ from "lodash"
export { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr, buildingTypes } from "./utils";

const SeoResults = ({ description, lang, meta, title, searchParams, location, ptypetag }) => {
    // console.log("searchParams => ", searchParams)
    const { areas, bedrooms, pType, type, price, commType, mustInclude } = searchParams;
    const actionStr = ACTION_TYPES[pType];
    const priceStr = getPriceStr(price)
    const bedRooms = searchParams.bedrooms;
    const typeStr = _.get(buildingTypes, type, type)
    const radius = searchParams.radius ? ` within ${searchParams.radius} miles` : ""
    const capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    var search_area = `${areas ? " "+toTitleCase(areas) : "Wiltshire"}`;
    var price_range = priceStr, property_type = `${typeStr}`;
    var action = `${capitalize(pType)}`;
    var bedroom_text = bedrooms + " bedrooms"

    if (!bedrooms)
        property_type = `${capitalize(typeStr)}`;

    var actionStrTitle=actionStr===" for sale in "?" for Sale in ":" to Rent in "

    var m_title =
    (price_range !== "" && property_type !== "" && bedrooms !== "" && radius !== "") ?
    `${property_type}${actionStrTitle}${search_area}${bedrooms}${radius}${price_range}` :
        (price_range !== "" && property_type !== "" && bedrooms !== "") ?
        // `${bedrooms} bedroom ${property_type}${actionStr}${search_area} ${price_range}` :
        `${property_type}${actionStrTitle}${search_area} with more than ${bedrooms} bedrooms ${price_range}` :
        (property_type !== "" && bedrooms !== "") ?
        // `${bedrooms} bedroom ${property_type}${actionStr}${search_area}` :
        `${property_type}${actionStrTitle}${search_area} with more than ${bedrooms} bedrooms` :
        (price_range !== "" && bedrooms !== "") ?
        // `${bedrooms} bedroom${actionStr}${search_area} ${price_range}` :
        `Property${actionStrTitle}${search_area} with more than ${bedrooms} bedrooms ${price_range}` :
        (price_range !== "" && property_type !== "") ?
        `${property_type}${actionStrTitle}${search_area} ${price_range}` :
        (price_range !== "" && radius !== "") ?
        `Property${actionStrTitle}${price_range}${search_area}${radius}`:
        (bedrooms !== "") ?
        // `${bedrooms} bedroom${actionStr}${search_area}` :
        `Property${actionStrTitle}${search_area} with more than ${bedrooms} bedrooms` :

        (property_type !== "") ?
        `${property_type}${actionStrTitle}${search_area}` :
        (price_range !== "") ?
        `Property${actionStrTitle}${search_area} ${price_range}` :
        (radius !== "") ?
        `Property${actionStrTitle}${search_area}${radius}` :
        `Property${actionStrTitle}${search_area}`;

   

    var m_description=
        // (price_range !== "" && property_type !== "" && bedrooms !== "") ?
        // `Find ${property_type}${actionStr}${search_area} with more than ${bedroom_text} ${price_range} with Strakers. Contact one of our property professionals today to get assistance in finding the best property in ${search_area}.`:
        (price_range !== "" && property_type !== "" && bedrooms !== "" && radius !== "") ?
        `Explore the list of${actionStr}${search_area}${radius} with more than ${bedroom_text} ${radius} ${price_range} Contact Strakers to help find a property in ${search_area}.`:
        (property_type !== "" && bedrooms !== "") ?
        `Find the latest ${property_type}${actionStr}${search_area} with more than ${bedroom_text}. Contact Strakers estate agents and letting agents in ${search_area}, to arrange a viewing.`:
        (price_range !== "" && bedrooms !== "") ?
        `Explore the list of property${actionStr}${search_area} with more than ${bedroom_text} ${price_range} with Strakers and Request a viewing for the property that interests you.`:
        (price_range !== "" && property_type !== "") ?
        `Check out the latest collection of ${property_type}${actionStr}${search_area} ${price_range} with Strakers estate agents in ${search_area}.`:
        (price_range !== "" && radius !== "") ?
        `Identify the property${actionStr}${search_area}${radius}. Book a viewing with Strakers estate agents in ${search_area}.` :
        (bedrooms !== "") ?
        `Explore property${actionStr}${search_area} with more than ${bedroom_text} here. Contact our expert estate agents today to get assistance in finding the right property in ${search_area}.`:
        (property_type !== "") ?
        `Looking for a ${property_type}${actionStr}${search_area}? Strakers estate agents are here to help.`:
        (price_range !== "") ?
        `Locate the right property${actionStr}${search_area} ${price_range} with Strakers estate agents. Book an appointment with one of our property experts in ${search_area}.`:
        (radius !== "") ?
        `Identify the best property${actionStr}${search_area}${radius}. Book an appointment with Strakers estate agents in ${search_area}.`:
        `Explore our latest collection of property${actionStr}${search_area}. Contact Strakers estate agents in ${search_area} to find the right property for you.`;

    // if (ptypetag === 'sold' || ptypetag === 'let') {
    //     m_description=
    //         (price_range !== "" && property_type !== "" && bedrooms !== "") ?
    //         `Find the list of ${property_type} that we ${property_type} with more than ${bedroom_text} ${price_range}. Contact one of our property professionals today to get assistance in finding the best property in ${search_area}.`:
    //         (property_type !== "" && bedrooms !== "") ?
    //         `Find the collection of ${property_type} that we${actionStr}${search_area} with more than ${bedroom_text}. Contact us for the best possible advice and support, tailored to you, from a really nice bunch of people.`:
    //         (price_range !== "" && bedrooms !== "") ?
    //         `Explore the list of properties that we${actionStr}${search_area} with more than ${bedroom_text} ${price_range} and contact our property professionals for the best property advice across selling, buying, letting and renting.`:
    //         (price_range !== "" && property_type !== "") ?
    //         `Check out our ${action} gallery of ${property_type} in ${search_area} ${price_range} with Strakers estate agents and letting agents in ${search_area}.`:
    //         (bedrooms !== "") ?
    //         `Find ${action} properties in ${search_area} with more than ${bedroom_text} here. Contact one of our property professionals today to get assistance in finding the right property in ${search_area}.`:
    //         (property_type !== "") ?
    //         `Searching for ${property_type}${actionStr}${search_area}? Our property experts in ${search_area} offer the best property advice across selling, buying, letting and renting. Contact us for the best possible advice and support, tailored to you.`:
    //         (price_range !== "") ?
    //         `Locate the collection of best properties that we've${actionStr}${search_area} ${price_range}. Book an appointment with one of our property experts in ${search_area} for the best property advice.`:
    //         `Explore our stunning range of property${actionStr}${search_area}. Contact our property professionals the best property advice across selling, buying, letting and renting.`;
    // }

    description = m_description;

    let metaTitle =  m_title || title ;

    const { pathname } = useLocation()

    var curentUrl = '';
    curentUrl = process.env.GATSBY_SITE_URL+pathname;

    // set no index for result pagination
    let hasPagination = false;
    if (pathname !== undefined && pathname) {
        let pageStr = pathname.split('page-');
        hasPagination = pageStr[1] || false;
        if (pageStr[0] !== undefined) {
            curentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
        }
    }

    if (!curentUrl.endsWith('/'))
            curentUrl = curentUrl + '/';

    //remove multiple slashes
    curentUrl = curentUrl.replace(/([^:]\/)\/+/g, "$1");
    //set lowercase url
    curentUrl = curentUrl.toLowerCase();

    let metaItems = [
        {
            name: `description`,
            content: description,
        },
        {
            property: `og:title`,
            content: metaTitle,
        },
        {
            property: `og:description`,
            content: description,
        },
        {
            property: `og:type`,
            content: `website`,
        },
        {
            name: `og:url`,
            content: curentUrl,
        },
        {
            name: `twitter:card`,
            content: `summary`,
        },
        {
            name: `twitter:creator`,
            content: `Strakers`,
        },
        {
            name: `twitter:title`,
            content: metaTitle,
        },
        {
            name: `twitter:description`,
            content: description,
        },
    ].concat(meta);


    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            link={[
                {
                    href: curentUrl,
                    rel: "canonical"
                }
            ]}
            title={metaTitle}
            titleTemplate={`%s | Strakers`}
            meta={metaItems}
        />
    )
}

SeoResults.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: ``,
  searchParams: [],
}

SeoResults.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  searchParams: PropTypes.any,
}

export default SeoResults
